import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import {
  NewIdeationState,
  resetOpportunityDetails,
  setOpportunityDetails,
  updateIdeationFieldState,
} from '../../../slices/ideationSlice/newIdeationSlice';

export type OpportunityDetailFieldKey = keyof NewIdeationState;

type UseOpportunityDetailsFormReturn = {
  formState: NewIdeationState;
  updateFieldValue: <K extends OpportunityDetailFieldKey>(
    field: K,
    value: NewIdeationState[K]
  ) => void;
  updateFormState: (values: Partial<NewIdeationState>) => void;
  resetFormState: () => void;
};

export const useOpportunityDetailsForm = (): UseOpportunityDetailsFormReturn => {
  const dispatch = useDispatch();
  const formState = useSelector((state: RootState) => state.newIdeation);

  const updateFieldValue = useCallback(
    <K extends OpportunityDetailFieldKey>(field: K, value: NewIdeationState[K]) => {
      dispatch(updateIdeationFieldState({ field, value }));
    },
    [dispatch]
  );

  const updateFormState = useCallback(
    (values: Partial<NewIdeationState>) => {
      dispatch(setOpportunityDetails(values));
    },
    [dispatch]
  );

  const resetFormState = useCallback(() => {
    dispatch(resetOpportunityDetails());
  }, [dispatch]);

  return {
    formState,
    updateFieldValue,
    updateFormState,
    resetFormState,
  };
};

export default useOpportunityDetailsForm;
